import React, { useState } from "react";
import "./All_Tab.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import All_Project_Card from "../all_project_card/All_Project_Card";
import Pagination_Holder from "../../common_components/Pagination_Holder/Pagination_Holder";
import { projects } from "../../../store";

const All_Tab = () => {
  const itemsPerPage = 7;
  const [currentPage, setCurrentPage] = useState(1);

  console.log("projects", projects?.[0]?.id);

  const totalPages = 2;

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div className="All_Tab">
      <div className="row">
        <div className="col-lg-4 col-sm-6">
          <All_Project_Card
            projectId={projects?.[0]?.id}
            imgSrc={projects?.[0]?.mainImg}
            projectName={projects?.[0]?.projectName}
            location={projects?.[0]?.location}
            subText={projects?.[0]?.descn?.[0]}
          />
        </div>

        <div className="col-lg-8 col-sm-6 ">
          <All_Project_Card
            projectId={projects?.[1]?.id}
            imgSrc={projects?.[1]?.mainImg}
            projectName={projects?.[1]?.projectName}
            location={projects?.[1]?.location}
            subText={projects?.[1]?.descn?.[0]}
          />
        </div>

        <div className="col-lg-8 col-sm-6 ">
          <All_Project_Card
            projectId={projects?.[2]?.id}
            imgSrc={projects?.[2]?.mainImg}
            projectName={projects?.[2]?.projectName}
            location={projects?.[2]?.location}
            subText={projects?.[2]?.descn?.[0]}
          />
        </div>

        <div className="col-lg-4 col-sm-6">
          <All_Project_Card
            projectId={projects?.[3]?.id}
            imgSrc={projects?.[3]?.mainImg}
            projectName={projects?.[3]?.projectName}
            location={projects?.[3]?.location}
            subText={projects?.[3]?.descn?.[0]}
          />
        </div>

        <div className="col-lg-4 col-sm-6">
          <All_Project_Card
            projectId={projects?.[4]?.id}
            imgSrc={projects?.[4]?.mainImg}
            projectName={projects?.[4]?.projectName}
            location={projects?.[4]?.location}
            subText={projects?.[4]?.descn?.[0]}
          />
        </div>

        <div className="col-lg-8 col-sm-6">
          <All_Project_Card
            projectId={projects?.[5]?.id}
            imgSrc={projects?.[5]?.mainImg}
            projectName={projects?.[5]?.projectName}
            location={projects?.[5]?.location}
            subText={projects?.[5]?.descn?.[0]}
          />
        </div>

        <div className="col-lg-8 col-sm-6">
          <All_Project_Card
            projectId={projects?.[6]?.id}
            imgSrc={projects?.[6]?.mainImg}
            projectName={projects?.[6]?.projectName}
            location={projects?.[6]?.location}
            subText={projects?.[6]?.descn?.[0]}
          />
        </div>

        <div className="col-lg-4 col-sm-6">
          <All_Project_Card
            projectId={projects?.[7]?.id}
            imgSrc={projects?.[7]?.mainImg}
            projectName={projects?.[7]?.projectName}
            location={projects?.[7]?.location}
            subText={projects?.[7]?.descn?.[0]}
          />
        </div>






        {/* <div className="col-lg-8 col-sm-6">
          <All_Project_Card
            projectId={projects?.[6]?.id}
            imgSrc={projects?.[6]?.mainImg}
            projectName={projects?.[6]?.projectName}
            location={projects?.[6]?.location}
            subText={projects?.[6]?.descn?.[0]}
          />
        </div> */}

        {/* <div className="col-lg-4 col-sm-6">
          <All_Project_Card
            imgSrc="/assets/images/home/our_services/client_verticle_images/img3.jpeg"
            projectName="Serene Space Studio"
            location="Vashi, New Mumbai"
            subText={
              "Seamlessly blending contemporary refinement with the building’s timeless charm, the project highlights the region’s..."
            }
          />
        </div>

        <div className="col-lg-8 col-sm-6 ">
          <All_Project_Card
            imgSrc="/assets/images/home/our_services/client_horizontal_images/img3.jpeg"
            projectName="Urban Zen Apartment "
            location="Kothrud, Pune"
            subText={
              "Luxoria Interiors was invited to complete the interior decoration of a four-bedroom, three-bathroom chalet in Alpe d’Huez, French Alps. The scope focused purely on..."
            }
          />
        </div>

         <div className="col-lg-4 col-sm-6">
          <All_Project_Card
           imgSrc="/assets/images/home/our_services/client_verticle_images/img4.jpeg"
            projectName="Serene Space Studio"
            location="Vashi, New Mumbai"
            subText={
              "Seamlessly blending contemporary refinement with the building’s timeless charm, the project highlights the region’s..."
            }
          />
        </div>

        <div className="col-lg-8 col-sm-6 ">
          <All_Project_Card
            imgSrc="/assets/images/home/our_services/client_horizontal_images/img4.jpeg"
            projectName="Urban Zen Apartment "
            location="Kothrud, Pune"
            subText={
              "Luxoria Interiors was invited to complete the interior decoration of a four-bedroom, three-bathroom chalet in Alpe d’Huez, French Alps. The scope focused purely on..."
            }
          />
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div> */}
      </div>
    </div>
  );
};

export default All_Tab;
